var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1001",
    "data-name": "Rectangle 1001",
    width: 17,
    height: 17,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "report_3",
    "data-name": "report 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    d: "M15.168,0H1.832A1.834,1.834,0,0,0,0,1.832V11.6a1.834,1.834,0,0,0,1.832,1.832H6.058l1.4,2.8A1.211,1.211,0,0,0,8.5,17a1.211,1.211,0,0,0,1.042-.767l1.4-2.8h4.227A1.834,1.834,0,0,0,17,11.6V1.832A1.834,1.834,0,0,0,15.168,0ZM16,11.6a.837.837,0,0,1-.836.836H10.634a.5.5,0,0,0-.446.275L8.651,15.787A.606.606,0,0,1,8.5,16a.606.606,0,0,1-.151-.208L6.812,12.712a.5.5,0,0,0-.445-.275H1.832A.837.837,0,0,1,1,11.6V1.832A.837.837,0,0,1,1.832,1H15.168A.837.837,0,0,1,16,1.832Z",
    fill: "#c19444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    d: "M7.276,7.168A1.565,1.565,0,1,0,8.841,8.733,1.567,1.567,0,0,0,7.276,7.168Zm0,2.134a.569.569,0,1,1,.569-.569A.57.57,0,0,1,7.276,9.3Z",
    transform: "translate(1.224 1.536)",
    fill: "#c19444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M7.276,1.758A1.567,1.567,0,0,0,5.711,3.323v2.3a1.565,1.565,0,0,0,3.13,0v-2.3A1.567,1.567,0,0,0,7.276,1.758Zm.569,3.866a.569.569,0,1,1-1.138,0v-2.3a.569.569,0,0,1,1.138,0Z",
    transform: "translate(1.224 0.377)",
    fill: "#c19444"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.cc5d8715e8670a25d6eac21d887703af.svg";
export { ForwardRef as ReactComponent };